import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

export function IcnPlus(props: AnimatedIconProps): ReactNode {
  const { active = false, ...rest } = props;
  return (
    <Svg {...rest} iconName="plus" data-open={active ? 'true' : 'false'}>
      <line x1="8" y1="3" x2="8" y2="13" />
      <line x1="3" y1="8" x2="13" y2="8" />
    </Svg>
  );
}
